<template>
  <div class='fk-head' >
     <el-tabs v-model="activeName"  type="border-card">
  <el-tab-pane name="first">
    <span slot="label"><i class="el-icon-s-platform"></i><label>公司审核</label></span>
     <el-container>
      <el-header class="other-list-header">
        <el-input placeholder="请输入查询内容" size="mini" v-model="searchText" clearable>
          <el-button slot="append" size="mini" @click="listSearch()">查询</el-button>
        </el-input>
      </el-header>
      <el-container>
        <el-main class="other-list-main" style="height:100%">
          <el-table :data="listData.list" border style="width: 100%">
            <el-table-column label="序号" width="50">
              <template slot-scope="scope">
                <span
                  style="margin-left: 10px"
                >{{ scope.$index+1+(listData.pageIndex-1)*listData.pageSize }}</span>
              </template>
            </el-table-column>
            <el-table-column label="公司名称" width="180">
              <template slot-scope="scope">
                <a
                  style="color:blue;cursor:pointer;"
                  @click="listEdit(scope.row,0)"
                >{{ scope.row.name }}</a>
              </template>
            </el-table-column>
            <el-table-column label="简称">
              <template slot-scope="scope">
                <span>{{ scope.row.briefName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="行业">
              <template slot-scope="scope">
                <span>{{ scope.row.business }}</span>
              </template>
            </el-table-column>
            <el-table-column label="统一社会信用代码" width="160">
              <template slot-scope="scope">
                <span>{{ scope.row.uniformCode }}</span>
              </template>
            </el-table-column>
             <el-table-column label="注册时间" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.stamp.substring(0,10) }}</span>
              </template>
            </el-table-column>
             <el-table-column label="管理员" width="80">
              <template slot-scope="scope">
                <span>{{ scope.row.applyUserName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="联系方式">
              <template slot-scope="scope">
                <span>
                  <div>{{ scope.row.mobile }}</div>
                  <div>{{ scope.row.phone }}</div>
                  </span>
              </template>
            </el-table-column>
             <el-table-column label="受访记录数" width="95">
              <template slot-scope="scope">
                <span>{{ scope.row.vistCount }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="60">
              <template slot-scope="scope">
                <span v-if="scope.row.state===0">待审核</span>
                <span v-if="scope.row.state===1">正常</span>
                <span v-if="scope.row.state===2" style="color:red;">禁用</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="77">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button
                    size="mini"
                    v-if="scope.row.state!=1"
                    type="primary"
                    @click="submit(scope.row.id,scope.row.applyUserId,1,scope.row.briefName,scope.row.business)"
                  >通过</el-button>
                  <el-button
                    size="mini"
                    v-if="scope.row.state!=2"
                    type="danger"
                    @click="submit(scope.row.id,scope.row.applyUserId,2,scope.row.briefName,scope.row.business)"
                  >禁用</el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <div class="other-list-page">
            <el-pagination
              background
              layout="prev, pager, next"
              small="true"
              :page-size="listData.pageSize"
              :page-count="listData.totalPageCount"
              :total="listData.totalCount"
              :current-page.sync="listData.pageIndex"
              @current-change="listSearch()"
            ></el-pagination>
          </div>
          <el-dialog title="编辑" :visible.sync="formVisible" width="60%">
            <div class="other-detail-div">
              <div class="table-div">
                <table style="width:95%">
                  <tr>
                    <th style="width:100px;">企业名称：</th>
                    <td colspan="3">{{ruleForm.name}}</td>
                    <th style="width:100px;">经度：</th>
                    <td style="width:100px;">{{ruleForm.longitude}}</td>
                    <th style="width:100px;">纬度：</th>
                    <td style="width:100px;">{{ruleForm.latitude}}</td>
                  </tr>
                  <tr>
                    <th>简称：</th>
                    <td colspan="7">
                    <input v-model="ruleForm.briefName" placeholder="请输入简称">
                    </td>
                  </tr>
                  <tr>
                    <th>行业：</th>
                    <td colspan="7">
                    <input v-model="ruleForm.business" placeholder="请输入行业">
                    </td>
                  </tr>
                  <tr>
                    <th>位置信息：</th>
                    <td colspan="7">{{ruleForm.location}}</td>
                  </tr>
                  <tr>
                    <th>社会信用代码：</th>
                    <td colspan="7">{{ruleForm.uniformCode}}</td>
                  </tr>
                  <tr>
                    <th>营业执照：</th>
                    <td colspan="7">{{ruleForm.uniformCode}}</td>
                  </tr>
                </table>
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button
                size="mini"
                v-if="ruleForm.state!=1"
                type="primary"
                @click="submit(ruleForm.id,ruleForm.applyUserId,1,ruleForm.briefName,ruleForm.business)"
              >通过</el-button>
              <el-button
                size="mini"
                v-if="ruleForm.state!=2"
                type="danger"
                @click="submit(ruleForm.id,ruleForm.applyUserId,2,ruleForm.briefName,ruleForm.business)"
              >禁用</el-button>
            </span>
          </el-dialog>
        </el-main>
      </el-container>
    </el-container>
  </el-tab-pane>
  </el-tabs>
   
  </div>
</template>
<script>
import publish_ from "@/components/publish"; //引用模块进来
import { getCompanyListData, updateCompanyState,sendCompanyAuditMsg } from "@/api/api";

export default {
  data() {
    return {
      activeName:'first',
      listData: {
        pageIndex: 1,
        pageSize: 10,
        totalCount: 10,
        totalPageCount: 1,
        list: []
      }, //列表集合数据
      searchText: "", //查询内容
      formVisible: false, //是否显示新增
      ruleForm: {} //表单绑定数据变量
    };
  },
  //初始化数据
  mounted() {
    this.getListData();
  },
  methods: {
    //查询列表
    getListData() {
      var _this = this;
      var para = {
        params: {
          SearchText: this.searchText,
          PageIndex: this.listData.pageIndex,
          PageSize: this.listData.pageSize
        }
      };
      getCompanyListData(para).then(res => {
        if (res.data.success) {
          _this.listData = res.data.data;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //点击查询
    listSearch() {
      this.getListData();
    },
    //list点击编辑
    listEdit(row) {
      //list点击修改
      this.ruleForm = row;
      this.formVisible = true;
    },
    //提交
    submit(id, applyUserId, state,briefName,business) {
      this.$confirm(state === 1 ? "确认提交？" : "确认禁用？")
        .then(_ => {
          //提交表单
          var params = { id: id,applyUserId: applyUserId, state: state,briefName:briefName,business:business };
          updateCompanyState(params).then(res => {
            if (res.data.success) {
              this.$message.success("提交成功");
              this.getListData();
            } else {
              this.$message.error(res.data.message);
            }
            this.formVisible = false;
          });
        })
        .catch(_ => {});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/fksys/checkCompany.vue